<section class="av-billing-box">
    <div class="av-billing-box__header">
        <mat-icon>receipt_long</mat-icon>
        <h2>{{ 'app.billing.subscription.title' | translate }}</h2>
    </div>

    @if (isLoading()) {
    <div role="status" [attr.aria-label]="'app.billing.invoices.loading' | translate">
        <div class="av-billing-skeleton av-billing-skeleton--line"></div>
        <div class="av-billing-skeleton av-billing-skeleton--line"></div>
        <div class="av-billing-skeleton av-billing-skeleton--line"></div>
    </div>
    } @else if (subscription(); as sub) {
    <div class="av-billing-box__title">
        <span>{{ plan()?.name ?? '-' }}</span>
        <span class="av-billing-pill" [class.av-billing-pill--warn]="isStatusWarning()">
            {{ statusKey() | translate }}
        </span>
    </div>

    <p class="av-billing-note m-0">
        {{ 'app.billing.subscription.renews_on' | translate }} {{ sub.current_period_end | date: 'mediumDate' }}
    </p>

    <p class="av-billing-note m-0">
        @if (sub.billable_device_quantity > 0) {
        {{ 'app.billing.subscription.quantities_with_devices' | translate: {
                seats: sub.billable_seat_quantity,
                devices: sub.billable_device_quantity
            } }}
        } @else {
        {{ 'app.billing.subscription.quantities' | translate: { seats: sub.billable_seat_quantity } }}
        }
    </p>

    @if (isCommitted()) {
    <p class="av-billing-note m-0">
        {{ 'app.billing.subscription.term_ends_on' | translate }} {{ commitment()?.current_term_end | date: 'mediumDate' }}
    </p>
    }

    @if (isPendingCancellation()) {
    <p class="av-billing-note m-0">{{ 'app.billing.subscription.pending_cancellation' | translate }}</p>
    }

    @if (!isReadOnly()) {
    <div class="av-billing-box__actions">
        @if (isPendingCancellation()) {
        <button mat-flat-button color="primary" (click)="resume.emit()">
            {{ 'app.billing.actions.resume' | translate }}
        </button>
        } @else {
        <button mat-flat-button color="primary" (click)="changePlan.emit()">
            {{ 'app.billing.actions.change_plan' | translate }}
        </button>
        <button mat-stroked-button [disabled]="!isCancellable()"
            [matTooltip]="isCancellable() ? '' : ('app.billing.danger.locked' | translate: lockedUntilParams())"
            (click)="cancel.emit()">
            {{ 'app.billing.actions.cancel' | translate }}
        </button>
        }
    </div>
    }
    } @else {
    <p class="av-billing-note m-0">{{ 'app.billing.empty.no_subscription' | translate }}</p>
    }
</section>
